module.exports = __webpack_public_path__ + "38bbf4d14c6bb5faceca2e75eca67903.jpg";